/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateFieldAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconAdd from 'DesignSystem/Svgs/TysiaIconAdd/index'



/** @type {import('Simple/types.js').View} */
export default function CreateFieldAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard/Content/Content/CreateFieldAction"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content'))}
 type="secondary"
 size="small"
 title="Add field"
 marginTop={dtSpaceXxs}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconAdd
{...childProps}
  viewPath={`${viewPath}/TysiaIconAdd`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}